var mod = function mod(n, m) {
  return (n % m + m) % m;
};

module.exports = mod;